import { render, staticRenderFns } from "./indexUsers.vue?vue&type=template&id=f58ca90e&"
import script from "./indexUsers.vue?vue&type=script&lang=ts&"
export * from "./indexUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports